import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';
import styles from './ErrorBoundary.module.css';

export default function ErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <div className={styles.container}>
        <h1 className={styles.errorCode}>{error.status}</h1>
        <h2 className={styles.errorTitle}>{error.statusText}</h2>
        <p className={styles.errorMessage}>
          {error.data?.message || 'Sorry, an unexpected error has occurred.'}
        </p>
        <Link className={styles.homeLink} to="/">
          Go back home
        </Link>
      </div>
    );
  }

  const errorMessage = error instanceof Error ? error.message : 'Unknown error';
  const errorStack = error instanceof Error ? error.stack : null;

  return (
    <div className={styles.container}>
      <h1 className={styles.errorCode}>Error</h1>
      <h2 className={styles.errorTitle}>Oops! Something went wrong</h2>
      <p className={styles.errorMessage}>{errorMessage}</p>
      <Link className={styles.homeLink} to="/">
        Go back home
      </Link>
      {import.meta.env.DEV && errorStack && (
        <pre className={styles.stackTrace}>{errorStack}</pre>
      )}
    </div>
  );
}
